import React from 'react'

import { artefactColors } from 'constants/color'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'

import EndQuizPopUp from './EndQuizPopUp'

import LeftControlBarTab from '../LeftControlBarTab'

const imgProps = {
    alt: 'quiz-icon',
    src: '/assets/revamp/quiz.new.svg',
    height: '80%',
    width: '80%',
}

const Quiz = ({ rightControl }) => {
    const { quiz } = useVideoContext()
    const {
        isQuizMode,
        toggleQuiz,
        isQuizDisabled,
        showQuizEndPopUp,
        toggleQuizEndPopUp,
        cancelQuiz,
    } = quiz

    return (
        <>
            <LeftControlBarTab
                iconProps={imgProps}
                isEnabled={isQuizMode}
                isDisabled={isQuizDisabled}
                onClick={toggleQuiz}
                title="quiz"
                rightControl={rightControl}
                activeColor={artefactColors.quiz}
            />
            <EndQuizPopUp
                isOpen={showQuizEndPopUp}
                close={toggleQuizEndPopUp}
                cancelQuiz={cancelQuiz}
            />
        </>
    )
}

export default Quiz
